/**
 * StatCard — compact metric display used in trip summaries.
 *
 * Props:
 *   label   — small text label below the number (e.g. "Total spent")
 *   value   — the big number/text to display
 *   sub     — optional smaller line below label (e.g. "12 txns")
 *   color   — optional Tailwind text color class (default: text-ink-100)
 *   onClick — optional; when given the card renders as a real button with a
 *             chevron affordance (a bare clickable div looks static, so nobody
 *             would ever discover it's tappable)
 *   ariaLabel — accessible name for the button form (e.g. "View all expenses")
 *
 * Extracted from TripOverviewPage so it can be shared with ExpensesScreen.
 */
import clsx from 'clsx'
import { ChevronRight } from 'lucide-react'

export default function StatCard({ label, value, sub, color, onClick, ariaLabel }) {
  const inner = (
    <>
      <div className={clsx('font-mono text-2xl font-bold mb-0.5', color || 'text-ink-100')}>
        {value}
      </div>
      <div className="text-xs text-ink-500 flex items-center gap-1">
        {label}
        {onClick && <ChevronRight size={11} className="text-ink-500" />}
      </div>
      {sub && <div className="text-xs text-ink-500 mt-0.5 font-mono">{sub}</div>}
    </>
  )

  if (onClick) {
    return (
      <button
        type="button"
        aria-label={ariaLabel || label}
        onClick={onClick}
        className="card-sm text-left w-full cursor-pointer transition-colors
                   hover:bg-ink-800 hover:border-lime-400/30"
      >
        {inner}
      </button>
    )
  }
  return <div className="card-sm">{inner}</div>
}
